/**
 * Stats blocks: when section enters view, animate numbers from 0 to final value (GSAP).
 */
(function () {
  function initStatsBlocks() {
    if (typeof gsap === "undefined") {
      setTimeout(initStatsBlocks, 50);
      return;
    }

    var sections = document.querySelectorAll('section[id^="stats-blocks-"]');
    sections.forEach(function (section) {
      if (section.dataset.statsAnimated === "true") return;
      const duration = parseInt(section.dataset.duration);
      var numberEls = section.querySelectorAll(".stats-blocks__number");
      if (!numberEls.length) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            section.dataset.statsAnimated = "true";

            numberEls.forEach(function (numberEl) {
              var inner = numberEl.querySelector(".stats-blocks__number-inner");
              if (!inner) return;

              var raw = numberEl.dataset.value || "0";
              var target = parseFloat(raw) || 0;
              var suffix = numberEl.dataset.appendPercent === "true" ? "%" : "";
              var obj = { value: 0 };

              gsap.to(obj, {
                value: target,
                duration: duration,
                ease: "power2.out",
                onUpdate: function () {
                  var v = obj.value;
                  inner.textContent =
                    (target % 1 !== 0 ? v.toFixed(1) : Math.round(v)) + suffix;
                },
              });
            });
          });
        },
        { rootMargin: "0px 0px -80px 0px", threshold: 0.1 }
      );

      observer.observe(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStatsBlocks);
  } else {
    initStatsBlocks();
  }

  document.addEventListener("shopify:section:load", initStatsBlocks);






  function initStatsGrid() {
  document.querySelectorAll('section[id^="stats-blocks-"]').forEach(function(section) {
    const grid = section.querySelector(".stats-blocks__grid-bg");
    if (!grid || grid.dataset.gridReady === "true") return;

    grid.dataset.gridReady = "true";

    const size = 48;
    let squares = [];

    function buildSquares() {
      grid.querySelectorAll(".stats-blocks__grid-square").forEach(el => el.remove());
      squares = [];

      const cols = Math.ceil(grid.offsetWidth / size);
      const rows = Math.ceil(grid.offsetHeight / size);

      for (let y = 0; y < rows; y++) {
        for (let x = 0; x < cols; x++) {
          const square = document.createElement("span");
          square.className = "stats-blocks__grid-square";
          square.style.left = `${x * size}px`;
          square.style.top = `${y * size}px`;
          grid.appendChild(square);
          squares.push(square);
        }
      }

      randomizeSquares();
    }

    function randomizeSquares() {
      squares.forEach(square => square.classList.remove("active"));

      const activeCount = 8;
      const chosen = [];
      const shuffled = [...squares].sort(() => 0.5 - Math.random());

      function isFarEnough(square) {
        const x1 = parseInt(square.style.left, 10);
        const y1 = parseInt(square.style.top, 10);

        return chosen.every(existing => {
          const x2 = parseInt(existing.style.left, 10);
          const y2 = parseInt(existing.style.top, 10);

          return Math.abs(x1 - x2) > size ||
                 Math.abs(y1 - y2) > size;
        });
      }

      for (const square of shuffled) {
        if (chosen.length >= activeCount) break;

        if (isFarEnough(square)) {
          square.classList.add("active");
          chosen.push(square);
        }
      }
    }

    function createRandomLine() {
      const line = document.createElement("span");
      const isHorizontal = Math.random() > 0.5;

      line.className = `stats-blocks__grid-line ${isHorizontal ? "is-horizontal" : "is-vertical"}`;

      const cols = Math.floor(grid.offsetWidth / size);
      const rows = Math.floor(grid.offsetHeight / size);

      const x = Math.floor(Math.random() * cols) * size;
      const y = Math.floor(Math.random() * rows) * size;

      line.style.left = `${x}px`;
      line.style.top = `${y}px`;

      grid.appendChild(line);

      const travel = isHorizontal ? grid.offsetWidth : grid.offsetHeight;

      line.animate(
        isHorizontal
          ? [
              { transform: `translateX(-${travel}px)`, opacity: 0 },
              { transform: `translateX(0px)`, opacity: 1, offset: 0.15 },
              { transform: `translateX(${travel}px)`, opacity: 0 }
            ]
          : [
              { transform: `translateY(-${travel}px)`, opacity: 0 },
              { transform: `translateY(0px)`, opacity: 1, offset: 0.15 },
              { transform: `translateY(${travel}px)`, opacity: 0 }
            ],
        { duration: 5500, easing: "linear" }
      );

      setTimeout(() => line.remove(), 5600);
    }

    buildSquares();

    setInterval(randomizeSquares, 5000);

    setInterval(() => {
      createRandomLine();
      createRandomLine();
    }, 2200);
  });
}
})();
